import { useMemo } from 'react';
import { useVariableDescriptionContext } from '../../VariableWizardContext';
import { useVariableUpdateContext } from 'pages/AutomationEngine/dialogs/ActionWizard/subsections/UpdateVariable/context';

export const useVariableContext = (forInitialize: boolean) => {
  const intializeCtx = useVariableDescriptionContext();
  const updateCtx = useVariableUpdateContext();

  return useMemo(
    () => (forInitialize ? intializeCtx : updateCtx),
    [forInitialize, intializeCtx, updateCtx]
  );
};
